<template>
  <div class="card-box">
    <div v-if="title" class="card-title">
      {{ title }}
    </div>
    <slot />
    <div v-if="showGap" class="card-gap"></div>
  </div>
</template>

<script>
export default {
  name: "CardBox",
  props: {
    title: {
      type: String,
      default: "",
    },
    showGap: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.card-box {
  background-color: #fffefd;
}
.card-title {
  display: flex;
  align-items: center;
  padding: 20px 30px;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  &::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 22px;
    background: #2e9adb;
    margin-right: 8px;
  }
}
.card-gap {
  height: 16px;
  background-color: #f2f2f2;
}
</style>
